<div [formGroup]="form">
  <!-- Row 1: Product Category, Products & Region -->
  <div class="row">
    <app-product-category-fields [form]="form" [lang]="lang"></app-product-category-fields>

    <div class="col-md-4" *ngIf="lang === 'en'">
      <div class="form-group mb-3">
        <label for="region" class="form-label"
          >Region <span class="ast">*</span></label
        >
        <select
          id="region"
          class="form-control"
          formControlName="region"
          [class.is-invalid]="isFieldInvalid('region')"
        >
          <option value="" disabled selected>Select a region</option>
          <option value="UK">UK</option>
          <option value="EU">EU</option>
          <option value="INT">Rest of world</option>
        </select>
        <div class="invalid-feedback" *ngIf="isFieldInvalid('region')">
          {{ messages.fieldRequired }}
        </div>
      </div>
    </div>
  </div>

  <!-- Row 2: Description -->
  <div class="row">
    <div class="col-md-12">
      <div class="form-group mb-3">
        <label for="description" class="form-label"
          >{{ labels.describeRequest }} <span class="ast">*</span></label
        >
        <textarea
          id="description"
          class="form-control"
          formControlName="description"
          [class.is-invalid]="isFieldInvalid('description')"
          rows="4"
          placeholder="{{ placeholders.describeYourRequest }}"
          maxlength="2000"
        ></textarea>
        <div class="invalid-feedback" *ngIf="isFieldInvalid('description')">
          <span *ngIf="form.get('description')?.hasError('required')">
            {{ messages.fieldRequired }}
          </span>
          <span *ngIf="form.get('description')?.hasError('minlength')">
            {{ messages.characterLimit }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
